export const actionTypes = {
  GET_INSTAGRAM_LIST_PENDING: "GET_INSTAGRAM_LIST_PENDING",
  GET_INSTAGRAM_LIST_SUCCESS: "GET_INSTAGRAM_LIST_SUCCESS",
  GET_INSTAGRAM_LIST_ERROR: "GET_INSTAGRAM_LIST_ERROR",

  ADD_INSTAGRAM_PUBLISHED_PENDING: "ADD_INSTAGRAM_PUBLISHED_PENDING",
  ADD_INSTAGRAM_PUBLISHED_SUCCESS: "ADD_INSTAGRAM_PUBLISHED_SUCCESS",
  ADD_INSTAGRAM_PUBLISHED_ERROR: "ADD_INSTAGRAM_PUBLISHED_ERROR",
};

const initialState = {
  getInstagramListPending: false,
  getInstagramListSuccess: false,
  getInstagramListError: null,

  addInstagramPublishedPending: false,
  addInstagramPublishedSuccess: false,
  addInstagramPublishedError: null,

  instagramList: [],
};

export default function instagramManagement(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_INSTAGRAM_LIST_PENDING:
    case actionTypes.GET_INSTAGRAM_LIST_SUCCESS:
    case actionTypes.GET_INSTAGRAM_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_INSTAGRAM_PUBLISHED_PENDING:
    case actionTypes.ADD_INSTAGRAM_PUBLISHED_SUCCESS:
    case actionTypes.ADD_INSTAGRAM_PUBLISHED_ERROR:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
